export const environment = {
  production: true,
  dev01: false,
  qaEnv: false,
  spritePath: 'assets/sprites/sprite.svg',
};
